<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">用户协议管理</div>
          <span class="m-title-s">对用户协议进行新增、编辑等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>协议列表
          </div>
          <div class="m-table-btn">
            <el-button @click="openPopup" type="primary" size="">新增协议内容</el-button>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border>
          <el-table-column prop="title" label="协议内容" width=""></el-table-column>
          <el-table-column prop="agreementType" label="协议类型" width=""></el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="110" align="center"></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" width="110" align="center"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row.id)" plain>编辑</el-button>
<!--              <el-button type="danger" size="mini" @click="thisDel(scope.row.id, scope.row.cooperator_name)" plain>删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="650px" center :close-on-click-modal="false">
      <div v-loading="formLoading" class="m-open-container">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="125px">
            <el-form-item label="ID" prop="id" hidden>
              <el-input v-model="form.id" type="hidden"></el-input>
            </el-form-item>
            <el-form-item label="协议列表标题: " prop="title">
              <el-input v-model="form.title" placeholder="输入协议列表标题"></el-input>
            </el-form-item>
            <el-form-item label="协议类型: " prop="agreementType">
              <el-input v-model="form.agreementType" placeholder="输入协议类型"></el-input>
            </el-form-item>
            <el-form-item label="协议内容: " prop="content">
              <div style="height: 600px;">
                <quill-editor
                  style="height: 450px"
                  class="editer"
                  v-model="form.content"
                  ref="myQuillEditor"
                  :options="editorOption"
                  @ready="onEditorReady($event)">
                </quill-editor>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
export default {
  components: { // 使用编辑器
    quillEditor
  },
  name: 'agreement',
  data () {
    return {
      openText: '新增',
      openState: false,
      formLoading: false,
      isLoading: true,
      isStatus: true,
      list: [],
      editorOption: {},
      form: {
        id: '',
        title: '',
        agreementType: '',
        content: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入协议标题', trigger: 'blur' }
        ],
        agreementType: [
          { required: true, message: '请输入协议类型', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入协议内容', trigger: 'blur' }
        ]
      }
    }
  },
  editor () {
    return this.$refs.myQuillEditor.quill
  },
  methods: {
    closeDialog: function () {
      this.form = {
        id: '',
        title: '',
        agreementType: '',
        content: ''
      }
      this.openText = '新增'
      this.openState = false
      this.formLoading = false
    },
    openPopup () {
      this.openState = true
    },
    onEditorReady (editor) {
      console.log(editor)
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.formLoading = true
          this.$axios.post('/agreement/save', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.listData()
                _this.openState = false
                _this.formLoading = false
              } else {
                _this.$message.error(res.msg)
                _this.formLoading = false
              }
            })
        } else {
          return false
        }
      })
    },
    thisDel (id) {
      let _this = this
      this.$messageBox.confirm('此操作将永久删除当前项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/agreement/del', {id: id})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.listData()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    openForm (id) {
      let _this = this
      this.openText = '编辑'
      _this.formLoading = true
      this.$axios.post('/agreement/form', {id: id})
        .then((res) => {
          if (res.status === 200) {
            _this.form = res.data
            _this.isLoading = false
            _this.openState = true
            _this.formLoading = false
          } else {
            _this.$message.error(res.msg)
          }
        })
    },
    // 管理员列表
    listData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/agreement/list')
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.listData()
  }
}
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.ql-editor{
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/Agreement.vue